export enum DocumentCategory {
  BorrowerIncome = 'Borrower Income',
  BorrowerID = 'Borrower ID',
  BorrowerOther = 'Borrower Other',
  CoborrowerIncome = 'Coborrower Income',
  CoborrowerID = 'Coborrower ID',
  CoborrowerOther = 'Coborrower Other',
  HomeVerification = 'Home Verification',
  ContractorWorkOrder = 'Contractor Work Order(s)',
  Funding = 'Funding',
}
